import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';


const Wrapper = ({title, loading, titleControls, item, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={item && item.archived}
        message={[
          'This item has been archived and is therefore no longer available.',
          item?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['item']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Stock', link: routes.stock.index},
  {title: 'Items', link: reverse(routes.stock.index, {tab: 'items'})}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Items', link: reverse(routes.archive.index, {tab: 'items'})}
];

export default Wrapper;
